module.exports = __webpack_public_path__ + "static/media/logo.613bddc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 354
// module chunks = 0